module.exports = __webpack_public_path__ + "static/media/typical1317.ac9afcf1.jpg";